import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const dashboard = 'dashboard/index';
const dashboardCompany = 'dashboard/company'

export const apiGetDashboard = async (val) => {
  const datas = await http.post(`${URL + dashboard}`, val);

  return datas.data.data;
};

export const apiDashboardCompany = async (val) => {
  const datas = await http.post(`${URL + dashboardCompany}`, val);

  return datas.data;
};
